import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 48 48" width="1em" height="1em" {...props}>
    <path d="M5.999 7v17.999h2V9h32v32H24.001v2h17.998V7h-36zm0 35.999h16v-16h-16v16zm2-14h12v12h-12v-12z" />
  </svg>
);

export default SvgComponent;
